import { render, staticRenderFns } from "./MasterHome.vue?vue&type=template&id=539efef6&scoped=true&"
import script from "./MasterHome.vue?vue&type=script&lang=js&"
export * from "./MasterHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539efef6",
  null
  
)

export default component.exports